import { Validator } from '../../Validator';
import { ValidatorInterface } from '../../ValidatorInterface';
import { ValidatorRegistry } from '../../ValidatorRegistry';
import { PropertiesInterface } from '../Property';
import { ITypeValidatesIncludes } from './ITypeValidatesIncludes';

export class IncludesValidator
  implements ValidatorInterface<ITypeValidatesIncludes>
{
  name = 'Includes';

  friendlyName = 'Includes';

  arrayOnly = false;

  array = false;

  description = 'shared.properties.validators.includes.description';

  types = ['String', 'Email', 'LongText', 'Url', 'PhoneNumber'];

  properties = {
    value: {
      type: 'String',
      default: '',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  } as PropertiesInterface;

  constructor(public config?: Validator) {}

  attach(type: ITypeValidatesIncludes) {
    type.addIncludesValidator(this);
  }
}

const includesValidator = new IncludesValidator(undefined);

ValidatorRegistry.register(IncludesValidator, includesValidator.name);

export { includesValidator };
